import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { isMobile } from 'dibs-media-query';
import { NavLogoHamburger } from './NavLogoHamburger';
import { NavItems } from './NavItems';
import { NavProfile } from './NavProfile';
import { NavLayoutContainer } from './NavLayoutContainer';
import { NavLogoutDownloadSellerApp } from './NavLogoutDownloadSellerApp';
import { useActiveNavLink } from './useActiveNavLink';
import { filterFalsy } from 'dibs-ts-utils/exports/filterFalsy';
import { type InternalNav_viewer$key } from './__generated__/InternalNav_viewer.graphql';

type Props = {
    viewer: InternalNav_viewer$key;
};

const viewerFragment = graphql`
    fragment InternalNav_viewer on Viewer {
        ...NavItems_viewer
        internalNavBarLinks(userId: $userId) {
            links {
                ...NavItems_links
                navItems {
                    ...useActiveNavLink_navItems
                }
            }
        }
    }
`;

export const InternalNav: FC<Props> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const internalNavBar = viewer?.internalNavBarLinks;
    const links = internalNavBar?.links;
    const navItems = internalNavBar?.links?.navItems?.filter(filterFalsy);
    const isMobileView = isMobile();

    const activeLink = useActiveNavLink({
        navItems,
    });

    if (!internalNavBar || !links) {
        return null;
    }

    return (
        <nav data-tn="top-navbar" id="js-header">
            <NavLayoutContainer>
                <NavLogoHamburger />
                <NavItems links={links} activeLink={activeLink} viewer={viewer} />
                {isMobileView ? <NavLogoutDownloadSellerApp /> : <NavProfile />}
            </NavLayoutContainer>
            <div id="nav-bottom-marker" />
        </nav>
    );
};
